interface ITaxRegion {
  title: string;
  percent: number;
}

const REGION_LOOKUP: {[key: string]: ITaxRegion} = {
  AB: {title: 'GST', percent: 0.05},
  NB: {title: 'HST', percent: 0.15},
  NL: {title: 'HST', percent: 0.15},
  NT: {title: 'GST', percent: 0.05},
  NS: {title: 'HST', percent: 0.15},
  NU: {title: 'GST', percent: 0.05},
  ON: {title: 'HST', percent: 0.13},
  PE: {title: 'HST', percent: 0.15},
  QC: {title: 'GST+QST', percent: 0.14975},
  YT: {title: 'GST', percent: 0.05},
  BC: {title: 'GST', percent: 0.05},
  MB: {title: 'GST', percent: 0.05},
  SK: {title: 'GST', percent: 0.05},
};

export const getTaxDetailsForRegion = (regionCode: string) => {
  return REGION_LOOKUP[regionCode || 'ON'];
};
